import { generateObjectHash } from '../utils/objectUtils';

/** Deduplicate concurrent API operations by retaining their promise under an idempotency key. */
export class IdempotencyManager {
  private readonly cache = new Map<string, Promise<unknown>>();

  /** Generate a stable idempotency key from request data. */
  static generateKey(data: object): Promise<string> {
    return generateObjectHash(data);
  }

  /** Return the cached promise for a key, removing rejected operations so they can be retried. */
  run<T>(key: string, operation: () => Promise<T>): Promise<T> {
    if (this.cache.has(key)) return this.cache.get(key)! as Promise<T>;

    const promise = operation().catch(error => {
      this.cache.delete(key);
      throw error;
    });

    this.cache.set(key, promise);
    return promise;
  }

  clear(key: string): void {
    this.cache.delete(key);
  }

  clearAll(): void {
    this.cache.clear();
  }
}